import GroupEditForm from "@/src/components/groups/group-edit.form";

export default function GroupEditScreen() {
  return <GroupEditForm />;
}
